import React, { FC } from 'react';
import styles from './NoPage.module.css';

interface NoPageProps {}

const NoPage: FC<NoPageProps> = () => (
  <div className={styles.NoPage}>
    <div className='pb-4 border rounded-5 p-4 w-100 contrasting-bg' style={{ minHeight: 'calc(100vh - 389.56px)' }}>
      <h2 className='text-center mb-4' style={{ color: '#086972' }}><strong>OBS... Denne siden eksisterer ikke...</strong></h2>
    </div>
  </div>
);

export default NoPage;
